import type { ReactElement, ReactNode } from 'react';
import type { IconGlyph } from '../Icon/IconGlyph';
import { fromInteractiveAtomToIconSize } from '../utils/InteractiveAtomProps';

export type MessageVariant = 'plain' | 'floating';
export type MessageSize = 'small' | 'default';
export type MessageType = 'plain' | 'info' | 'success' | 'warning' | 'error';

export const fromMessageToIconSize = fromInteractiveAtomToIconSize;

export const fromMessageTypeToIconGlyph: {
  [Key in MessageType]: IconGlyph;
} = {
  info: 'fa-info-circle',
  success: 'fa-check-circle',
  warning: 'fa-exclamation-circle',
  error: 'fa-xmark-circle',
  plain: 'fa-info-circle',
};

export const fromMessageTypeToIconColor: {
  [Key in MessageType]: string;
} = {
  info: 'text-status-info',
  success: 'text-status-success',
  warning: 'text-status-warning',
  error: 'text-status-error',
  plain: 'text-plain',
};

export type MessageProps = {
  variant: MessageVariant;
  type: MessageType;
  className?: string;
  title?: ReactNode;
  message?: ReactNode;
  dismissible?: boolean;
  size?: MessageSize;
  statusIcon?: boolean;
  link?: ReactElement;
  onRemove?: () => void;
  loading?: boolean;
} & ({ message: ReactNode } | { title: ReactNode });
